export default "__VITE_ASSET__Ddmn1wV0__"